import { atom } from "recoil"
import { addMemberSelectorOverview } from "src/types/organization/OrganizationMember"

export const teamMembersState = atom<addMemberSelectorOverview[]>({
  key: "atoms/organization/team/teamMembersState",
  default: undefined,
})
